export const RECOMMENDED_FORMS_AND_DOCS_FILE_TYPES = 'DOC, DOCX, PDF, XLS, XLSX, JPG, JPEG, PNG';
